import service from "./index.axios";

export default service;
